import {
  BackgroundSettingsV1,
  CameraSettingsV1,
  CharacterSettingsV1,
  LabelSettingsV1,
  PlaybackSettingsV1,
  SceneSettings,
} from '../types';
import apiRequest from './apiRequest';

export default async function postScene(
  jobID: string,
  sceneSettings: {
    backgroundSettings?: BackgroundSettingsV1;
    cameraSettings?: CameraSettingsV1;
    characterSettings?: CharacterSettingsV1;
    labelSettings?: LabelSettingsV1;
    playbackSettings?: PlaybackSettingsV1;
  },
) {
  return await apiRequest<SceneSettings>(
    'mogen-orchestration',
    `/jobs/${jobID}/scene`,
    {
      method: 'POST',
      body: JSON.stringify(sceneSettings),
    },
  );
}
